/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Comms/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Status from './Status/index'
import Tysiav2CommsIcon from 'DesignSystem/Svgs/Tysiav2CommsIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Comms({
  children,
  viewPath = "/App/Account/Topbar/Tabs/QuickAccess/Tab/Icon/Comms",
  hovered,
  selected
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<Tysiav2CommsIcon
  viewPath={`${viewPath}/Tysiav2CommsIcon`}
 width={16}
 height={16}
 fill2={hovered && selected ? dtColorsWhite : hovered ? dtColorsWhite : selected ? dtColorsWhite : dtColorsWhite}
/>
<Status
  viewPath={`${viewPath}/Status`}
/>
{children}
</React.Fragment>)
}